import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ServiceMetadataActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ServiceMetadata/ServiceMetadataBrowser")
	}

	render() {
		return (
			<Activity 
				name="ServiceMetadata"
				RenderedComponent={this.RenderedComponent}
				context="ServiceMetadata"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ServiceMetadataActivity)
